export default "__VITE_ASSET__BU0AK6xG__"